import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
import { OwaDate } from 'owa-datetime';

export default mutatorAction('setScheduleTime', function setScheduleTime(scheduleTime: OwaDate) {
    getStore().scheduleTime = scheduleTime;
});
